<template>
  <div id="app">
    <keep-alive>
      <component :is="this.$route.meta.layout || 'div'">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </component>
      <!-- <router-view /> -->
    </keep-alive>
  </div>
</template>
<script>
  export default {
    name: 'App',
    mounted() {
      this.$store.dispatch('setBaseUrl', {
        url:
          window.location.protocol +
          '//' +
          window.location.host.split('/')[0] +
          '/api'
      })
    },
    methods: {
      /* showMoreDetails() {
        console.log('showMoreDetails App')
      } */
    }
  }
</script>
<style>
  ::-webkit-scrollbar {
    opacity: 0;
    width: 5px;
    height: 5px;
    border-radius: 1rem;
    background: transparent;
  }

  ::-webkit-scrollbar:hover {
    opacity: 1;
  }

  :hover::-webkit-scrollbar-thumb {
    border-radius: 1rem !important;
    background-color: #65717c !important;
  }
</style>
